// pages/Html.js
// Bài giảng Thiết kế Web tĩnh - HTML
// Nội dung bám theo đề cương: Bài 1 (Tổng quan WWW - HTML) và Bài 2 (Thiết kế Web tĩnh)

import React from "react";

const styles = {
  page: {
    maxWidth: 900,
    margin: "0 auto",
    padding: "24px 20px 64px",
    color: "#1f2937",
    lineHeight: 1.65,
    fontSize: 16,
  },
  pageTitle: {
    fontSize: 30,
    fontWeight: 800,
    margin: "0 0 4px",
    color: "#111827",
  },
  pageSub: { color: "#6b7280", margin: "0 0 24px", fontSize: 15 },
  toc: {
    background: "#f8fafc",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: "16px 20px",
    margin: "0 0 32px",
  },
  tocTitle: { fontWeight: 700, margin: "0 0 8px" },
  tocLink: { color: "#2563eb", textDecoration: "none" },
  lessonTitle: {
    fontSize: 24,
    fontWeight: 800,
    margin: "40px 0 6px",
    color: "#1d4ed8",
    borderBottom: "2px solid #dbeafe",
    paddingBottom: 6,
  },
  meta: { color: "#6b7280", fontSize: 14, margin: "0 0 12px" },
  goalBox: {
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 10,
    padding: "12px 18px",
    margin: "0 0 24px",
  },
  h3: { fontSize: 19, fontWeight: 700, margin: "28px 0 8px", color: "#111827" },
  pre: {
    background: "#0f172a",
    color: "#e2e8f0",
    borderRadius: 10,
    padding: "14px 16px",
    overflowX: "auto",
    fontSize: 14,
    lineHeight: 1.5,
    margin: "10px 0 18px",
  },
  code: {
    background: "#f1f5f9",
    padding: "1px 6px",
    borderRadius: 4,
    fontSize: 14,
    color: "#be123c",
  },
  table: { borderCollapse: "collapse", width: "100%", margin: "10px 0 18px", fontSize: 15 },
  th: { border: "1px solid #d1d5db", padding: "8px 10px", background: "#f3f4f6", textAlign: "left" },
  td: { border: "1px solid #d1d5db", padding: "8px 10px" },
  note: {
    background: "#fefce8",
    border: "1px solid #fde68a",
    borderRadius: 8,
    padding: "10px 14px",
    margin: "14px 0",
    fontSize: 15,
  },
};

const Code = ({ children }) => <pre style={styles.pre}><code>{children}</code></pre>;

// Link thực hành tới W3Schools (mở tab mới)
const practiceLinkStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  background: "#ecfdf5",
  border: "1px solid #a7f3d0",
  color: "#047857",
  textDecoration: "none",
  borderRadius: 8,
  padding: "6px 12px",
  fontSize: 14,
  fontWeight: 600,
  margin: "0 0 18px",
};
const Practice = ({ href, label }) => (
  <div>
    <a style={practiceLinkStyle} href={href} target="_blank" rel="noopener noreferrer">
      ▶ Thực hành tại W3Schools{label ? `: ${label}` : ""}
    </a>
  </div>
);
const Goal = ({ items }) => (
  <div style={styles.goalBox}>
    <strong>Mục tiêu của bài:</strong>
    <ul style={{ margin: "8px 0 0", paddingLeft: 22 }}>
      {items.map((t, i) => (
        <li key={i}>{t}</li>
      ))}
    </ul>
  </div>
);

const Html = () => (
  <div style={styles.page}>
    <h1 style={styles.pageTitle}>Thiết kế Web tĩnh — HTML</h1>
    <p style={styles.pageSub}>
      Bài giảng nhập môn ngôn ngữ HTML và kỹ thuật thiết kế trang Web tĩnh.
    </p>

    <Practice href="https://www.w3schools.com/" label="Trang chủ học & thực hành" />
    <Practice href="https://www.w3schools.com/html/tryit.asp?filename=tryhtml_default" label="Try it Yourself (viết & chạy code ngay)" />

    <nav style={styles.toc}>
      <p style={styles.tocTitle}>Nội dung</p>
      <div><strong>Bài 1. Tổng quan về WWW – ngôn ngữ HTML</strong> (2 giờ)</div>
      <ul style={{ margin: "4px 0 12px", paddingLeft: 22 }}>
        <li><a style={styles.tocLink} href="#b1-1">1.1. Lịch sử WWW</a></li>
        <li><a style={styles.tocLink} href="#b1-2">1.2. Nhập môn ngôn ngữ HTML</a></li>
        <li><a style={styles.tocLink} href="#b1-3">1.3. Trang và văn bản trên trang</a></li>
        <li><a style={styles.tocLink} href="#b1-4">1.4. Ngôn ngữ đặc tả Script</a></li>
        <li><a style={styles.tocLink} href="#b1-5">1.5. CSS</a></li>
      </ul>
      <div><strong>Bài 2. Thiết kế Web tĩnh</strong> (2 giờ)</div>
      <ul style={{ margin: "4px 0 0", paddingLeft: 22 }}>
        <li><a style={styles.tocLink} href="#b2-1">2.1. Tổng quan</a></li>
        <li><a style={styles.tocLink} href="#b2-2">2.2. Trang và văn bản trên trang</a></li>
        <li><a style={styles.tocLink} href="#b2-3">2.3. Bảng biểu (Table) và trang khung (Frame)</a></li>
        <li><a style={styles.tocLink} href="#b2-4">2.4. Multimedia trên trang Web</a></li>
        <li><a style={styles.tocLink} href="#b2-5">2.5. Các yếu tố động trên trang</a></li>
        <li><a style={styles.tocLink} href="#b2-6">2.6. Khung nhập – Form</a></li>
        <li><a style={styles.tocLink} href="#b2-7">2.7. Liên kết</a></li>
      </ul>
    </nav>

    {/* ===================== BÀI 1 ===================== */}
    <h2 style={styles.lessonTitle}>Bài 1: Tổng quan về WWW – ngôn ngữ HTML</h2>
    <p style={styles.meta}>Thời gian: 2 giờ</p>
    <Goal
      items={[
        "Trình bày được lịch sử sử dụng của WWW;",
        "Mô tả được cấu trúc của một trang HTML và các thẻ HTML cơ bản, cách bố trí, xử lý và ứng dụng file CSS;",
        "Thực hiện thiết kế được giao diện;",
        "Biết cách tổ chức được thông tin trong trang chủ và bố trí văn bản trên trang;",
        "Ghi nhớ các lệnh điều khiển của ngôn ngữ đặc tả Script;",
        "Thực hiện các thao tác an toàn với máy tính.",
      ]}
    />

    <h3 id="b1-1" style={styles.h3}>1.1. Lịch sử WWW</h3>
    <p>
      <strong>WWW (World Wide Web)</strong> là hệ thống các tài liệu siêu văn bản
      được liên kết với nhau và truy cập qua Internet. Web do <strong>Tim
      Berners-Lee</strong> đề xuất năm <strong>1989</strong> tại CERN và ra mắt
      công khai năm 1991.
    </p>
    <p>Ba công nghệ nền tảng của Web:</p>
    <ul>
      <li><strong>HTML</strong> – ngôn ngữ đánh dấu siêu văn bản, mô tả cấu trúc nội dung trang.</li>
      <li><strong>URL</strong> – địa chỉ định danh tài nguyên trên Web (ví dụ <span style={styles.code}>https://example.com/index.html</span>).</li>
      <li><strong>HTTP/HTTPS</strong> – giao thức truyền tải tài liệu giữa trình duyệt (client) và máy chủ (server).</li>
    </ul>
    <p>
      Mô hình hoạt động: trình duyệt gửi <em>yêu cầu (request)</em> tới máy chủ →
      máy chủ trả về <em>phản hồi (response)</em> là trang HTML → trình duyệt
      hiển thị (render) nội dung.
    </p>

    <h3 style={{ ...styles.h3, fontSize: 17 }}>Trình duyệt – công cụ để đọc HTML</h3>
    <p>
      Bản thân file HTML chỉ là <strong>văn bản thuần (text)</strong> chứa các thẻ
      đánh dấu. Nếu mở bằng trình soạn thảo (Notepad…) bạn chỉ thấy mã, chứ không
      thấy trang web. <strong>Phải có trình duyệt (web browser)</strong> để đọc,
      phân tích (parse) các thẻ HTML, áp dụng CSS và chạy JavaScript, rồi
      <em>hiển thị (render)</em> thành giao diện trực quan cho người dùng.
    </p>
    <p>
      Nói cách khác: <strong>không có trình duyệt thì HTML gần như vô nghĩa</strong> —
      nó chỉ là một mớ ký tự. Trình duyệt chính là phần mềm "dịch" HTML thành trang
      web mà ta nhìn thấy và tương tác được.
    </p>
    <p>Các trình duyệt phổ biến hiện nay:</p>
    <ul>
      <li><strong>Google Chrome</strong> – phổ biến nhất, nhân Blink.</li>
      <li><strong>Mozilla Firefox</strong> – mã nguồn mở, nhân Gecko.</li>
      <li><strong>Microsoft Edge</strong> – mặc định trên Windows, nhân Blink.</li>
      <li><strong>Safari</strong> – mặc định trên macOS/iPhone, nhân WebKit.</li>
      <li><strong>Opera</strong>, <strong>Cốc Cốc</strong> – cũng dùng nhân Blink.</li>
    </ul>
    <div style={styles.note}>
      <strong>Bên trong trình duyệt</strong> có một bộ phận gọi là <em>render engine</em>
      (Blink, Gecko, WebKit…) chịu trách nhiệm đọc HTML/CSS và vẽ ra màn hình. Cùng
      một file HTML có thể hiển thị hơi khác nhau giữa các trình duyệt, nên khi thiết
      kế web cần <strong>kiểm tra trên nhiều trình duyệt</strong>.
    </div>
    <p>
      <strong>Cách thực hành nhanh:</strong> tạo file <span style={styles.code}>index.html</span>,
      gõ vài thẻ HTML, lưu lại rồi <strong>kéo thả file vào trình duyệt</strong> (hoặc
      bấm đúp) để xem kết quả.
    </p>
    <Practice href="https://www.w3schools.com/whatis/" label="What is HTML/Web" />

    <h3 id="b1-2" style={styles.h3}>1.2. Nhập môn ngôn ngữ HTML</h3>
    <p>
      HTML dùng các <strong>thẻ (tag)</strong> dạng <span style={styles.code}>&lt;tên&gt;...&lt;/tên&gt;</span>.
      Một tài liệu HTML5 cơ bản có cấu trúc:
    </p>
    <Code>{`<!DOCTYPE html>
<html lang="vi">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Trang đầu tiên</title>
  </head>
  <body>
    <h1>Xin chào!</h1>
    <p>Đây là trang web đầu tiên của tôi.</p>
  </body>
</html>`}</Code>
    <p>Một số thẻ HTML cơ bản:</p>
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.th}>Thẻ</th>
          <th style={styles.th}>Ý nghĩa</th>
        </tr>
      </thead>
      <tbody>
        <tr><td style={styles.td}><span style={styles.code}>&lt;h1&gt;…&lt;h6&gt;</span></td><td style={styles.td}>Tiêu đề, từ lớn đến nhỏ</td></tr>
        <tr><td style={styles.td}><span style={styles.code}>&lt;p&gt;</span></td><td style={styles.td}>Đoạn văn bản</td></tr>
        <tr><td style={styles.td}><span style={styles.code}>&lt;a href&gt;</span></td><td style={styles.td}>Liên kết (hyperlink)</td></tr>
        <tr><td style={styles.td}><span style={styles.code}>&lt;img src&gt;</span></td><td style={styles.td}>Chèn hình ảnh</td></tr>
        <tr><td style={styles.td}><span style={styles.code}>&lt;ul&gt;, &lt;ol&gt;, &lt;li&gt;</span></td><td style={styles.td}>Danh sách không/ có thứ tự</td></tr>
        <tr><td style={styles.td}><span style={styles.code}>&lt;div&gt;, &lt;span&gt;</span></td><td style={styles.td}>Khối / đoạn để gom nhóm và tạo bố cục</td></tr>
      </tbody>
    </table>
    <Practice href="https://www.w3schools.com/html/html_basic.asp" label="HTML Basic" />

    <h3 id="b1-3" style={styles.h3}>1.3. Trang và văn bản trên trang</h3>
    <p>Định dạng văn bản và tổ chức thông tin trang chủ:</p>
    <Code>{`<h1>Trang chủ</h1>
<p>Văn bản <strong>in đậm</strong>, <em>in nghiêng</em>, <u>gạch chân</u>.</p>
<ul>
  <li>Mục 1</li>
  <li>Mục 2</li>
</ul>
<hr />            <!-- đường kẻ ngang -->
<br />            <!-- xuống dòng -->`}</Code>
    <div style={styles.note}>
      <strong>Mẹo bố trí:</strong> dùng các thẻ ngữ nghĩa
      <span style={styles.code}>&lt;header&gt;</span>,
      <span style={styles.code}>&lt;nav&gt;</span>,
      <span style={styles.code}>&lt;main&gt;</span>,
      <span style={styles.code}>&lt;footer&gt;</span> để trang dễ đọc và tốt cho SEO.
    </div>
    <Practice href="https://www.w3schools.com/html/html_formatting.asp" label="HTML Formatting" />

    <h3 id="b1-4" style={styles.h3}>1.4. Ngôn ngữ đặc tả Script</h3>
    <p>
      <strong>JavaScript</strong> là ngôn ngữ kịch bản (script) chạy trong trình
      duyệt, giúp trang web có khả năng tương tác. Nhúng bằng thẻ
      <span style={styles.code}>&lt;script&gt;</span>:
    </p>
    <Code>{`<button onclick="chao()">Bấm vào đây</button>
<script>
  function chao() {
    alert("Xin chào, bạn vừa bấm nút!");
  }
</script>`}</Code>
    <p>Các lệnh điều khiển cơ bản: biến (<span style={styles.code}>let</span>, <span style={styles.code}>const</span>), rẽ nhánh (<span style={styles.code}>if/else</span>), vòng lặp (<span style={styles.code}>for</span>, <span style={styles.code}>while</span>), hàm (<span style={styles.code}>function</span>).</p>
    <Practice href="https://www.w3schools.com/js/" label="JavaScript Tutorial" />

    <h3 id="b1-5" style={styles.h3}>1.5. CSS</h3>
    <p>
      <strong>CSS (Cascading Style Sheets)</strong> dùng để trình bày (màu sắc,
      bố cục, font…) cho trang HTML. Có 3 cách áp dụng: nội tuyến (inline), nội
      bộ (<span style={styles.code}>&lt;style&gt;</span>) và file ngoài
      (<span style={styles.code}>&lt;link&gt;</span>).
    </p>
    <Code>{`<head>
  <link rel="stylesheet" href="style.css" />
</head>

/* style.css */
body { font-family: Arial, sans-serif; }
h1   { color: #2563eb; }
.box { padding: 16px; border: 1px solid #ddd; border-radius: 8px; }`}</Code>
    <Practice href="https://www.w3schools.com/css/" label="CSS Tutorial" />

    {/* ===================== BÀI 2 ===================== */}
    <h2 style={styles.lessonTitle}>Bài 2: Thiết kế Web tĩnh</h2>
    <p style={styles.meta}>Thời gian: 2 giờ</p>
    <Goal
      items={[
        "Mô tả được các chế độ hiển thị một trang Web;",
        "Có khả năng đưa một file vào Web;",
        "Có khả năng tạo được các bảng biểu và các Frame;",
        "Tạo được ứng dụng bảng liên kết trang Web;",
        "Xây dựng được các ứng dụng Multimedia;",
        "Sử dụng tốt các công cụ hỗ trợ thiết kế Web;",
        "Thực hiện các thao tác an toàn với máy tính.",
      ]}
    />

    <h3 id="b2-1" style={styles.h3}>2.1. Tổng quan</h3>
    <p>
      <strong>Web tĩnh</strong> là trang mà nội dung được cố định trong file
      HTML; mọi người dùng đều nhận nội dung giống nhau, máy chủ chỉ trả về file
      có sẵn (khác với web động sinh nội dung theo dữ liệu/người dùng). Quy trình
      thiết kế: dựng cấu trúc HTML → trình bày bằng CSS → thêm tương tác bằng
      JavaScript.
    </p>
    <Practice href="https://www.w3schools.com/html/html_intro.asp" label="HTML Introduction" />

    <h3 id="b2-2" style={styles.h3}>2.2. Trang và văn bản trên trang</h3>
    <p>Tổ chức bố cục một trang điển hình bằng các thẻ ngữ nghĩa:</p>
    <Code>{`<body>
  <header><h1>Tên website</h1></header>
  <nav>Menu điều hướng</nav>
  <main>
    <article>Nội dung chính</article>
    <aside>Thanh bên</aside>
  </main>
  <footer>Thông tin liên hệ © 2025</footer>
</body>`}</Code>
    <Practice href="https://www.w3schools.com/html/html_layout.asp" label="HTML Layout" />

    <h3 id="b2-3" style={styles.h3}>2.3. Bảng biểu (Table) và trang khung (Frame)</h3>
    <p><strong>Bảng (Table):</strong></p>
    <Code>{`<table border="1">
  <tr>
    <th>Họ tên</th>
    <th>Điểm</th>
  </tr>
  <tr>
    <td>Nguyễn Văn A</td>
    <td>9.0</td>
  </tr>
</table>`}</Code>
    <p>
      <strong>Trang khung (Frame):</strong> dùng
      <span style={styles.code}>&lt;iframe&gt;</span> để nhúng một trang web khác
      vào trang hiện tại.
    </p>
    <Code>{`<iframe src="trangphu.html" width="600" height="400" title="Trang phụ"></iframe>`}</Code>
    <Practice href="https://www.w3schools.com/html/html_tables.asp" label="HTML Tables" />
    <Practice href="https://www.w3schools.com/html/html_iframe.asp" label="HTML Iframes" />

    <h3 id="b2-4" style={styles.h3}>2.4. Multimedia trên trang Web</h3>
    <Code>{`<!-- Hình ảnh -->
<img src="anh.jpg" alt="Mô tả ảnh" width="300" />

<!-- Âm thanh -->
<audio controls src="nhac.mp3"></audio>

<!-- Video -->
<video controls width="480">
  <source src="phim.mp4" type="video/mp4" />
</video>`}</Code>
    <Practice href="https://www.w3schools.com/html/html_media.asp" label="HTML Media" />

    <h3 id="b2-5" style={styles.h3}>2.5. Các yếu tố động trên trang</h3>
    <p>
      Dù là web tĩnh, ta vẫn tạo được hiệu ứng động phía client bằng CSS và
      JavaScript: chuyển động (transition/animation), đổi nội dung khi bấm nút,
      hiệu ứng khi rê chuột.
    </p>
    <Code>{`<style>
  .nut { transition: background .3s; }
  .nut:hover { background: #2563eb; color: #fff; }
</style>

<button class="nut" onclick="document.getElementById('kq').innerText='Đã bấm!'">
  Bấm thử
</button>
<p id="kq"></p>`}</Code>
    <Practice href="https://www.w3schools.com/css/css3_animations.asp" label="CSS Animations" />

    <h3 id="b2-6" style={styles.h3}>2.6. Khung nhập – Form</h3>
    <p>Form dùng để thu thập dữ liệu người dùng:</p>
    <Code>{`<form action="/dangky" method="post">
  <label>Họ tên: <input type="text" name="hoten" required /></label><br />
  <label>Email: <input type="email" name="email" /></label><br />
  <label>Mật khẩu: <input type="password" name="matkhau" /></label><br />
  <label>Giới tính:
    <select name="gioitinh">
      <option>Nam</option>
      <option>Nữ</option>
    </select>
  </label><br />
  <textarea name="ghichu" rows="3" placeholder="Ghi chú"></textarea><br />
  <button type="submit">Đăng ký</button>
</form>`}</Code>
    <Practice href="https://www.w3schools.com/html/html_forms.asp" label="HTML Forms" />

    <h3 id="b2-7" style={styles.h3}>2.7. Liên kết</h3>
    <Code>{`<!-- Liên kết tới trang khác -->
<a href="gioithieu.html">Giới thiệu</a>

<!-- Liên kết ngoài, mở tab mới -->
<a href="https://google.com" target="_blank" rel="noopener">Google</a>

<!-- Liên kết nội bộ trong trang (neo) -->
<a href="#b2-1">Lên đầu mục 2.1</a>

<!-- Liên kết email -->
<a href="mailto:lienhe@example.com">Gửi email</a>`}</Code>
    <Practice href="https://www.w3schools.com/html/html_links.asp" label="HTML Links" />

    <div style={{ ...styles.note, marginTop: 32 }}>
      <strong>Thực hành an toàn:</strong> luôn sao lưu file mã nguồn, kiểm tra
      trang trên nhiều trình duyệt, không nhúng nội dung từ nguồn không tin cậy,
      và dùng HTTPS khi xuất bản trang.
    </div>
  </div>
);

export default Html;
